//// Nice selectors
(function($, window, undefined) {

  var defaults = {
    initValue:false,
    onChange: null,
    desktopSlideOut:false,
    key:null
  }

  function wbskSelects(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.optionsWrap = this.element.find('.wbsk-ui-option-toggle__options-wrap')
    this.options = this.element.find('.wbsk-ui-option-toggle__input')
    this.confirm = this.element.find('.wbsk-ui-option-toggle__confirm')
    this.key = this.settings.key
    this.value = this.settings.initValue ? this.settings.initValue : this.options.first().val()
    this.bind()
    this.updateValue(this.value,true)
  }

  wbskSelects.prototype = {
  
    
    bind:function(){
      var _this = this;
      
      this.element.on('click', function(e) {
        if (_this.element.hasClass('is-open')) {
          _this.closeAll()
        } else {
          _this.open()
        }
      }) 
      
      this.options.on('change', function(e) {
        var value = $(e.target).val()
        if(value != _this.value){
          _this.updateValue(value,true) 
        }
      })   
      
      this.confirm.on('click', function(e) {
        e.preventDefault()
      })  
    },
    
    closeAll:function(){
      $('.wbsk-ui-option-toggle__bg-close').remove()
      $('.wbsk-ui-option-toggle').removeClass('is-open')
      this.unBindClick()
    },
    
    open:function(){
      var _this = this
      this.closeAll()
      if(this.settings.desktopSlideOut == true){
        this.element.prepend('<span class="wbsk-ui-option-toggle__bg-close"></span>')
      }
      this.element.addClass('is-open')
      setTimeout(function(){
      _this.bindClick()
      },100)
    },
    
    bindClick:function(){
      var _this = this
      $('body').bind('click',function(e){
        if(!$(_this.element).has($(e.target)).length || !$(e.target).parents(_this.element).length || $(e.target).hasClass('wbsk-ui-option-toggle__bg-close')){
          _this.closeAll()
        }
      });
    },
    
    unBindClick:function(){
      $('body').unbind('click')
    },
    
    updateValue:function(value,udpdateSiblings){
      var _this = this,
          element = _this.options.filter(function(){
            return value == $(this).val()
          }).first()
      _this.value = value
      element.prop('checked',true).parent().addClass('is-selected').siblings().removeClass('is-selected')
      var event = new CustomEvent('update' , {bubbles: true});
      event.wbskSelect = this
      this.element[0].dispatchEvent(event);
      if (typeof this.settings.onChange === "function") {
        this.settings.onChange(_this)
      }
      //update any sibling selector
      if(udpdateSiblings && _this.settings.siblingSelector){
        _this.settings.siblingSelector.forEach(function(item){
        var sibling = item.data('wbskSelects')
          if(sibling){
            sibling.updateValue(value,false)
          }
        })
      }
    },
  }

  $.fn.wbskSelects = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskSelects', new wbskSelects(this, settings))
    })
  }

}(jQuery, window));




//// product form
(function($, window, undefined) {

  var defaults = {}
  
  function wbskProductForm(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.input_id = this.element.find('.wbsk-product-form__id')
    this.updateAvlVariantsByOption()
    this.update()
  }

  wbskProductForm.prototype = {
    
    updateAvlVariantsByOption:function(){
      var _this = this,
          selectedOptions = _this.settings.selectedOptions,
          data = _this.settings.data
      
      _this.settings.avlVariantsByOption = selectedOptions.map(function(selectedOption,index){
        return data.variants.filter(function(variant){
          var last = index - 1 
          if((!selectedOptions[last] || variant.options[last] == selectedOptions[last]) && variant.visibility.hide_on_main != 'true'){
            return variant
          }
        }).map(function(variant){
          return variant.options[index]
        })
      })

      _this.settings.hiddenVariantsByOption = selectedOptions.map(function(selectedOption,index){
        return data.variants.filter(function(variant){
          if(variant.visibility.hide_on_main == 'true'){
            return variant
          }
        }).map(function(variant){
          return variant.options[index]
        })
      })

      var event = new CustomEvent('updateAvlVariantsByOption' , {bubbles: true});
      event.avlVariantsByOption = _this.settings.avlVariantsByOption;
      event.hiddenVariantsByOption = _this.settings.hiddenVariantsByOption;
      this.element[0].dispatchEvent(event);
    },
    
    updateSelectedOptions:function(index,value,updateAvlVariantsByOption){
      this.settings.selectedOptions[index] = value
      if(updateAvlVariantsByOption){
        this.updateAvlVariantsByOption()
      }
    },
    
    getVariantFromOptions:function(options){
      var variants = this.settings.data.variants;
      
      for (v_i = 0, v_length = variants.length; v_i < v_length; v_i++) {
        var variant = variants[v_i] ,
            isVariant = true,
            variantOptions = variant.options;
         
        for (o_i = 0, o_length = options.length; o_i < o_length; o_i++) {
          if(options[o_i] != variantOptions[o_i] ){
            isVariant = false
            break
          }
        }
        if(isVariant){
          return variant
          break 
        }
      }
      
      return false
    },   
    
    update:function(force){
      var currentId = this.input_id.val()
      if(this.settings.variant && this.settings.variant.id != currentId || force){
        this.input_id.val(this.settings.variant.id)
        var event = new CustomEvent('update' , {bubbles: true});
        event.variant = this.settings.variant
        this.element[0].dispatchEvent(event);
      }
    }
  }

  $.fn.wbskProductForm = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskProductForm', new wbskProductForm(this, settings))
    })
  }

}(jQuery, window));



/// Radios
(function($, window, undefined) {

  var defaults = {
    onChange: null,
  }

  function wbskRadio(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.value = false
    this.inputs = this.element.find('input')
    this.bind()
  }

  wbskRadio.prototype = {
    bind:function(){
      var _this = this;
      this.inputs.on('change',function(){
        _this.update($(this).val(),'regular')
      })
    },
    
    updateOptions:function(avlOptions, hiddenOptions){
      var _this = this
      $.each(_this.inputs,function(){
        if(avlOptions.indexOf($(this).val()) > -1){
          $(this).prop('disabled',false)
        }else{
          $(this).prop('disabled','disabled')
          if($(this).prop('checked')){
            _this.update(avlOptions[0],'udpateOptions')
          }
        }

        if (hiddenOptions && hiddenOptions.indexOf($(this).val()) > -1) {
          $(this).parents('li').hide();
        } else {
          $(this).parents('li').show();
        }
      })
    },
    
    update:function(value,type){
      var _this = this
      _this.value = value
      $.each(_this.inputs,function(input){
         $(this).prop('checked',$(this).val() == _this.value)
      })
      
      if (_this.settings.onChange && typeof _this.settings.onChange === "function") {
        _this.settings.onChange(_this,type)
      }
 
    }
  }
  
  $.fn.wbskRadio = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskRadio', new wbskRadio(this, settings))
    })
  }

}(jQuery, window));

//// Quant selectors
(function($, window, undefined) {

  var defaults = {
    onChange: null,
  }

  function qntSel(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  qntSel.prototype = {
  
    init: function() {  
      var _this = this
      this.minus = this.element.find('span').first(),
      this.plus = this.element.find('span').last(),
      this.input = this.element.find('input')   
      this.min = 0
      this.max = Math.pow(10, 1000) 
      
      if(this.input.attr('min')){
        this.min = this.input.attr('min')
      }
      
      if(this.input.attr('max')){
        this.max = this.input.attr('max')
      }
     
      //bind handlers
      this.minus.on('click', function(e) {
        _this.updateValue('minus')
      })
      this.plus.on('click', function(e) {
        _this.updateValue('plus')
      }) 
      this.input.on('change', function(e) {
        //change hanlder
      }) 
    },
    
    updateValue:function(math){
      var a = parseInt(this.input.val()),
          p1 = a + 1,
          m1 = a - 1
                 
      if(math == 'plus' && p1 <= this.max){
        this.input.val(p1).trigger('change')
      }
      if(math == 'minus' && m1 >= this.min){
        this.input.val(m1).trigger('change')
      }
    },
    

  }

  $.fn.qntSel = function(settings) {
    return this.each(function () {
      $.data(this, 'qntSel', new qntSel(this, settings))
    })
  }

}(jQuery, window));

//// swiper JQ wrapper
(function($, window, undefined) {

  var defaults = {
    loop: false,
    freeMode: false,
    autoHeight: false,
    preloadImages: true,
    pagination: false,
    navigation: false,
    lazy: {
      loadPrevNext: true,
      loadPrevNextAmount: 6,
    }
  }

  function wbskSwiper(element , settings) {
    this.element = element
    this.settings = $.extend({}, defaults, settings)
    this.init()
  }

  wbskSwiper.prototype = {
    init: function() {      
      var _this = this
      _this.swiper = new Swiper(_this.element,_this.settings)
    },
  }
  
  $.fn.wbskSwiper = function(settings) {
    $.data(this[0], 'wbskSwiper', new wbskSwiper(this, settings))[0]
  }

}(jQuery, window));

